import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const ActionButton = ({ icon, label, onClick, variant = 'dark', className = '' }) => {
  const base = 'flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors shadow-sm';
  const variants = {
    dark:    'bg-[#0f172a] hover:bg-slate-800 text-white',
    primary: 'bg-blue-600 hover:bg-blue-700 text-white',
    outline: 'bg-white hover:bg-slate-50 text-slate-700 border border-slate-200',
  };
  return (
    <button onClick={onClick} className={`${base} ${variants[variant]} ${className}`}>
      {icon && <SafeIcon icon={icon} className="text-lg" />}
      {label}
    </button>
  );
};

export default ActionButton;